import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
} from "@mui/material";
import { View } from "react-native";
import { StyleSheet } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useSelector, useDispatch } from "react-redux";
import { InfoComponent, ImageComponent } from "../components/FullComponent.js";
import { updateConfirmedStone } from "../services/ConnectDataBase";
import { getStatusDelivery } from "../services/Functions";
import { backgroundColor, backgroundColor2 } from "../constants/Constants.js";
import { translateText } from "../translations/translationService";
import { STONE_DELIVERY_SCREEN_COLORS } from "../style/colors.js";

export default function StoneDeliveryScreen({ route }) {
  const dispatch = useDispatch();
  const [isFirstConfirmed, setIsFirstConfirmed] = useState(false);
  const [isSecondConfirmed, setIsSecondConfirmed] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const infoData = useSelector((state) => state.infoData.infoData);
  const { eFabrica, ...data } = infoData;
  const codeScan = useSelector((state) => state.infoData.infoData.MO);
  const PO = useSelector((state) => state.infoData.infoData.PO);
  const name = useSelector((state) => state.user.name);
  const confirmed = "CONFIRMED";
  const lang = useSelector((state) => state.lang.value);
  let status = "stoneStatus";
  let codePage = 7;
  let ConfirmedFirstTeam = "PIEDRAS";
  let ConfirmedSecondTeam = "TALLER";
  const screenName = "StoneDeliveryScreen";

  const newArray = eFabrica
    .filter(({ tipo }) => tipo === "PIEDRAS")
    .map(({ codigo, quilates, peso, numeropiedras }) => ({
      codigo,
      quilates: parseFloat(quilates * infoData.cantidad).toFixed(2),
      peso: parseFloat(peso * infoData.cantidad).toFixed(2),
      numeropiedras: numeropiedras
        ? parseFloat(numeropiedras * infoData.cantidad).toFixed(0)
        : "-",
    }));

  useEffect(() => {
    getStatusDelivery(codeScan, codePage, status, PO)
      .then((estado) => {
        setIsFirstConfirmed(estado[0]);
        setIsSecondConfirmed(estado[1]);
      })
      .catch((error) => {
        console.error(error);
        setIsFirstConfirmed(false);
        setIsSecondConfirmed(false);
      });
  }, []);

  const handleConfirm = (action) => {
    if (action === "first" && !isFirstConfirmed) {
      setIsFirstConfirmed(true);

      let tzoffset = new Date().getTimezoneOffset() * 60000;
      let localISOTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, -1);

      updateConfirmedStone(
        codeScan,
        codePage,
        ConfirmedFirstTeam,
        name,
        localISOTime,
        confirmed,
        PO,
        screenName
      );
    } else if (action === "second" && !isSecondConfirmed) {
      setIsSecondConfirmed(true);

      let tzoffset = new Date().getTimezoneOffset() * 60000;
      let localISOTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, -1);

      updateConfirmedStone(
        codeScan,
        codePage,
        ConfirmedSecondTeam,
        name,
        localISOTime,
        confirmed,
        PO,
        screenName
      );
    }
  };

  const TableComponent = () => {
    return (
      <TableContainer
        component={Paper}
                    sx={{ maxHeight: 400, backgroundColor: STONE_DELIVERY_SCREEN_COLORS.BACKGROUND_TABLE_CONTAINER }}>
        <Table stickyHeader size='small'>
          <TableHead>
                          <TableRow sx={{ backgroundColor: STONE_DELIVERY_SCREEN_COLORS.BACKGROUND_TABLE_HEADER }}>
              <TableCell
                align='center'
                sx={{ color: "black", fontWeight: "bold" }}>
                {translateText("Código", lang)}
              </TableCell>
              <TableCell
                align='center'
                sx={{ color: "black", fontWeight: "bold" }}>
                {translateText("Quilates", lang)}
              </TableCell>
              <TableCell
                align='center'
                sx={{ color: "black", fontWeight: "bold" }}>
                {translateText("AVG", lang)}
              </TableCell>
              <TableCell
                align='center'
                sx={{ color: "black", fontWeight: "bold" }}>
                {translateText("Nº Piedras", lang)}
              </TableCell>
              <TableCell
                align='center'
                sx={{ color: "black", fontWeight: "bold" }}>
                {translateText("Check piedras", lang)}
              </TableCell>
              <TableCell
                align='center'
                sx={{ color: "black", fontWeight: "bold" }}>
                {translateText("Check taller", lang)}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {newArray.map((item, index) => (
              <TableRow key={index}>
                <TableCell align='center' sx={{ color: "white" }}>
                  {item.codigo}
                </TableCell>
                <TableCell align='center' sx={{ color: "white" }}>
                  {item.quilates}
                </TableCell>
                <TableCell align='center' sx={{ color: "white" }}>
                  {item.peso}
                </TableCell>
                <TableCell align='center' sx={{ color: "white" }}>
                  {item.numeropiedras}
                </TableCell>
                <TableCell align='center'>
                  <Checkbox
                    checked={
                      checkedItems[item.codigo]?.checkPiedras ||
                      isFirstConfirmed
                    }
                    onChange={() => handleConfirm("first")}
                    disabled={isFirstConfirmed}
                    sx={{ color: isFirstConfirmed ? "grey" : "white" }}
                  />
                </TableCell>
                <TableCell align='center'>
                  <Checkbox
                    checked={
                      checkedItems[item.codigo]?.checkTaller ||
                      isSecondConfirmed
                    }
                    onChange={() => handleConfirm("second")}
                    disabled={isSecondConfirmed}
                    sx={{ color: isSecondConfirmed ? "grey" : "white" }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <LinearGradient
      colors={backgroundColor()}
      style={styles.backgrounOptionDos}>
      <View style={styles.container}>
        <View style={styles.row}>
          <View style={[styles.column, { flex: 1 }]}>
            <InfoComponent data={data} />
          </View>
          <View style={[styles.column, { marginLeft: 20, flex: 1 }]}>
            <ImageComponent data={data} />
          </View>
        </View>
        <View style={{ height: "50vh" }}>
          <TableComponent />
        </View>
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  header: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: STONE_DELIVERY_SCREEN_COLORS.BORDER_LIGHT,
    paddingVertical: 10,
    backgroundColor: STONE_DELIVERY_SCREEN_COLORS.BACKGROUND_TABLE_HEADER,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  headerCell: {
    flex: 1,
    fontWeight: "bold",
    textAlign: "center",
    color: "white",
  },
  dataContainer: {
    flex: 1,
    marginTop: 50,
    backgroundColor: backgroundColor2,
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: STONE_DELIVERY_SCREEN_COLORS.BORDER_LIGHT,
    paddingVertical: 10,
  },
  cell: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: "white",
  },
  backgrounOptionDos: {
    flex: 1,
  },
  container: {
    flex: 1,
    padding: 10,
  },
  column: {
    flexDirection: "column",
  },
});
